import { redirect, RouteObject } from "react-router-dom";

export const fundFamilySetupRoutes: RouteObject = {
  id: "fundFamilySetup",
  path: "setup",
  children: [
    {
      id: "fundFamilySetupIndex",
      index: true,
      loader: () => redirect("fund"),
    },
    {
      id: "fundFamilySetupProfile",
      path: "profile",
      handle: {
        showSidebar: true,
        description: "Fund Family Setup - Profile",
      },
      lazy: async () => {
        const { FundFamilySetupProfilePage } = await import(
          "features/fund-family/setup/FundFamilySetupProfilePage"
        );
        return { Component: FundFamilySetupProfilePage };
      },
    },
    {
      id: "fundFamilySetupDates",
      path: "dates",
      handle: {
        showSidebar: true,
        description: "Fund Family Setup - Dates",
      },
      lazy: async () => {
        const { FundFamilySetupDatesPage } = await import(
          "features/fund-family/setup/FundFamilySetupDatesPage"
        );
        return { Component: FundFamilySetupDatesPage };
      },
    },
    {
      id: "fundFamilySetupEntities",
      path: "entities",
      handle: {
        showSidebar: true,
        description: "Fund Family Setup - Entities",
      },
      lazy: async () => {
        const { FundFamilySetupEntitiesPage } = await import(
          "features/fund-family/setup/FundFamilySetupEntitiesPage"
        );
        return { Component: FundFamilySetupEntitiesPage };
      },
    },
    {
      id: "fundFamilySetupTransactions",
      path: "transactions",
      handle: {
        showSidebar: true,
        description: "Fund Family Setup - Transactions",
      },
      lazy: async () => {
        const { FundFamilySetupTransactionsPage } = await import(
          "features/fund-family/setup/FundFamilySetupTransactionsPage"
        );
        return { Component: FundFamilySetupTransactionsPage };
      },
    },
    {
      id: "fundFamilySetupCalculations",
      path: "calculations",
      handle: {
        showSidebar: true,
        description: "Fund Family Setup - Calculations",
      },
      lazy: async () => {
        const { FundFamilySetupCalculationsPage } = await import(
          "features/fund-family/setup/FundFamilySetupCalculationsPage"
        );
        return { Component: FundFamilySetupCalculationsPage };
      },
    },
    {
      id: "fundFamilySetupClasses",
      path: "classes",
      handle: {
        showSidebar: true,
        description: "Fund Family Setup - Classes",
      },
      lazy: async () => {
        const { FundFamilySetupClassesPage } = await import(
          "features/fund-family/setup/FundFamilySetupClassesPage"
        );
        return { Component: FundFamilySetupClassesPage };
      },
    },
    {
      id: "fundFamilySetupFees",
      path: "fees",
      children: [
        {
          id: "fundFamilySetupFeesIndex",
          index: true,
          loader: () => redirect("configuration"),
        },
        {
          id: "fundFamilySetupFeesConfiguration",
          path: "configuration",
          handle: {
            showSidebar: true,
            description: "Fund Family Setup - Fees",
          },
          lazy: async () => {
            const { FundFamilySetupFeesPage } = await import(
              "features/fund-family/setup/FundFamilySetupFeesPage"
            );
            return { Component: FundFamilySetupFeesPage };
          },
        },
        {
          id: "fundFamilySetupFeesCreate",
          path: "create",
          lazy: async () => {
            const { FundFamilySetupFeeCreatePage } = await import(
              "features/fund-family/setup/FundFamilySetupFeeCreatePage"
            );
            return { Component: FundFamilySetupFeeCreatePage };
          },
        },
        {
          id: "fundFamilySetupFeesEdit",
          path: "edit/:feeId",
          lazy: async () => {
            const { FundFamilySetupFeeEditPage } = await import(
              "features/fund-family/setup/FundFamilySetupFeeEditPage"
            );
            return { Component: FundFamilySetupFeeEditPage };
          },
        },
      ],
    },
    {
      id: "fundFamilySetupWaterfalls",
      path: "waterfalls",
      handle: {
        showSidebar: true,
        description: "Fund Family Setup - Waterfalls",
      },
      lazy: async () => {
        const { FundFamilySetupWaterfallsPage } = await import(
          "features/fund-family/setup/FundFamilySetupWaterfallsPage"
        );
        return { Component: FundFamilySetupWaterfallsPage };
      },
    },
  ],
};
